import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Grid from '@mui/material/Grid';

import AddIconImage from '../../shared/svg/plus.svg';

import ImageCard from '../../components/ImageCard';
import ListPage from '../../layouts/ListPage';
import { Box } from '@mui/material';
import useSWR from 'swr';
import { getTranslation, languages } from '../../utils/translate';
import StatusActions from '../../components/shared/StatusActions';
import { useState } from 'react';
import { pageNumber, pageSize } from '../../utils/pagination';

function BarcodesList() {
  const retailer = useSelector(state => state.retailer);
  const [language, setLanguage] = useState(languages[0]);
  const [page, setPage] = useState(pageNumber);

  const { data: barcodes, isLoading: barcodesLoading } = useSWR({
    url: `barcode?meta=*`,
    fields: [
      "*",
      "beef_product_id.*",
      "beef_product_id.translations.*",
    ],
    filter: {
      _and: [
        {
          '_or': [
            {
              owner: {
                id: {
                  '_eq': retailer.id
                }
              }
            }
          ]
        },
      ],
    },
    sort: '-date_created',
    limit: 23,
    page,
  });

  const summaryValues = [
    {
      label: 'Total',
      value: barcodes?.meta?.filter_count?.toLocaleString() || '-',
    },
  ];

  return (
    <ListPage
      summaries={ summaryValues }
      title={'Barcodes'}
      searchStorageKey={'BARCODES'}
      searchOnly={['BARCODES']}
      breadcrumbsLinks={[
        {
          url: '/recipes-menu',
          content: 'Content Library',
        },
        {
          url: '/codes-menu',
          content: 'Codes',
        },
      ]}
      language={language}
      setLanguage={setLanguage}
      pageNumber={page}
      setPageNumber={setPage}
      numberOfPages={Math.ceil(barcodes?.meta?.filter_count / pageSize)}
      loading={barcodesLoading}
    >
      <Box sx={{ flexGrow: 1, my: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={6} md={4} lg={3} xl={2}>
            <Link to={'create'}>
              <ImageCard
                item={{ title: 'New Barcode', url: AddIconImage }}
                imageBackground='#fff'
              />
            </Link>
          </Grid>

          {barcodes?.data?.map((barcode) => (
            <Grid
              key={barcode.id}
              item
              xs={12}
              md={4}
              lg={3}
              xl={2}
            >
              <ImageCard
                url={`/barcodes/${barcode.id}`}
                item={{
                  title: barcode.code,
                  description: getTranslation(barcode.beef_product_id, { key: 'languages_id', code: language.code }, 'translations')?.name || 'Not Linked To Product',
                  url: `${process.env.REACT_APP_API_URL}/assets/${barcode?.beef_product_id?.image}`,
                }}
                footerAction={(
                  <StatusActions
                    id={barcode.id}
                    table={'barcode'}
                    payload={{
                      status: 'published',
                      id: barcode.id
                    }}
                  />
                )}
                imageBackground='#fff'
                imageFit='contain'
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </ListPage>
  )
}

export default BarcodesList